/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateRequesterTokenRequest } from '../models/CreateRequesterTokenRequest';
import type { PagedRequesterTokens } from '../models/PagedRequesterTokens';
import type { RequesterToken } from '../models/RequesterToken';
import type { UpdateRequesterTokenRequest } from '../models/UpdateRequesterTokenRequest';
import { request as __request } from '../core/request';

export class RequesterTokensService {

    /**
     * Search for requester tokens
     * @returns PagedRequesterTokens Success
     * @throws ApiError
     */
    public static async getRequesterTokens({
query,
page = '0',
pageSize = '30',
}: {
/** Search term **/
query?: string,
/** Page number **/
page?: string,
/** Page size **/
pageSize?: string,
}): Promise<PagedRequesterTokens> {
        const result = await __request({
            method: 'GET',
            path: `/requester_tokens/`,
            query: {
                'query': query,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Create (or restore) a new RequesterToken
     * @returns RequesterToken Success
     * @throws ApiError
     */
    public static async postRequesterTokens({
requestBody,
}: {
requestBody: CreateRequesterTokenRequest,
}): Promise<RequesterToken> {
        const result = await __request({
            method: 'POST',
            path: `/requester_tokens/`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Get existing RequesterToken
     * @returns RequesterToken Success
     * @throws ApiError
     */
    public static async getRequesterTokenByToken({
token,
}: {
token: string,
}): Promise<RequesterToken> {
        const result = await __request({
            method: 'GET',
            path: `/requester_tokens/${token}`,
            errors: {
                403: `Access Denied`,
                404: `Not found`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Delete existing RequesterToken
     * @returns void 
     * @throws ApiError
     */
    public static async deleteRequesterTokenByToken({
token,
}: {
token: string,
}): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/requester_tokens/${token}`,
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Update existing RequesterToken
     * @returns RequesterToken Success
     * @throws ApiError
     */
    public static async patchRequesterTokenByToken({
token,
requestBody,
}: {
token: string,
requestBody: UpdateRequesterTokenRequest,
}): Promise<RequesterToken> {
        const result = await __request({
            method: 'PATCH',
            path: `/requester_tokens/${token}`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                404: `Not found`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

}